import { isSet } from '../utils/isSet';
import { Table } from './Table';

class HireSelection {
    constructor(root){
        this.root = root;

        this.selectionTables = this.root.querySelectorAll('table');

        this.init();
    }

    init(){
        this.selectionTables.forEach((tableElm)  =>  {
            const table = new Table(tableElm);
        })
    }
}

exports.HireSelection = HireSelection